<mat-menu #appMenu="matMenu">
    <button mat-menu-item (click)="onCreateAppointment()"  [disabled]="!canCreateAppointment">{{ 'MENU.CREATE-APPOINTMENT' | translate }}</button> 
    <button mat-menu-item (click)="onEdit()">{{ 'MENU.EDIT' | translate }}</button>
    <button mat-menu-item (click)="onDelete()">{{ 'MENU.DELETE' | translate }}</button>
  </mat-menu>
  
  <button mat-icon-button [matMenuTriggerFor]="appMenu" class="p-0 m-0" *ngIf="waitlistItem">
    <mat-icon>more_vert</mat-icon>
  </button>
  